export var SEEK_SUB_REGEX = /[^|]+$/;
export var SCOPE_HANDLER_SESSION_KEY = 'oi__scopes';
export var NAMESPACE_TOGGLES = 'oi__toggles';
export var SEEK_CLAIMS_PREFIX = 'http://seek/claims';
//# sourceMappingURL=index.js.map